import { render, staticRenderFns } from "./FilterSCTPTracks.vue?vue&type=template&id=5252f63e"
import script from "./FilterSCTPTracks.vue?vue&type=script&lang=js"
export * from "./FilterSCTPTracks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports